export default "__VITE_ASSET__97ea2b41__"